import React from "react";
import { STRINGS } from "../../../strings";
import { translate } from "../../../translate";
import { AppModalAction, InfoModal } from "../../Generic/AppModal/AppModal";

interface Props {
  isOpen: boolean;
  isLoading: boolean;
  onClickSignOut: () => void;
  onRequestClose: () => void;
}

const ForgotPinModal = (props: Props) => {
  const actions: AppModalAction[] = [
    {
      key: "sign_out",
      variant: "soft",
      color: "black",
      children: translate(STRINGS.SIGN_OUT),
      onClick: props.onClickSignOut,
    },
    {
      key: "cancel",
      variant: "link",
      children: translate(STRINGS.CANCEL),
      onClick: props.onRequestClose,
    },
  ];

  return (
    <InfoModal
      title={translate(STRINGS.PLEASE_NOTE) + "!"}
      message={translate(STRINGS.FORGOT_PIN_CODE_DIALOG_MESSAGE)}
      isOpen={props.isOpen}
      isLoading={props.isLoading}
      actions={actions}
      onRequestClose={props.onRequestClose}
    />
  );
};

export default React.memo(ForgotPinModal);
